angular.module('ushahidi.plans', [
])

.config(require('./plans-routes.js'));
